module.exports = __webpack_public_path__ + "img/afganistan.a5d5609.webp";